import TagDisplay from './TagDisplay';

export default TagDisplay;
